<template>
  <div>
    <purchase-order-list v-show="activeKey===1" ref="list" :orderStatus="orderStatus" :storers="storers" @add="add" @getDetail="getDetail"/>
    <purchase-order-detail v-show="activeKey===2" ref="detail" :storers="storers" @back="back"/>
  </div>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import PurchaseOrderList from '@/views/inbound/purchase_order_make/PurchaseOrderList.vue'
import PurchaseOrderDetail from '@/views/inbound/purchase_order_make/PurchaseOrderDetail.vue'

export default {
  name: 'PurchaseOrderMake',
  components: { PurchaseOrderList, PurchaseOrderDetail },
  data() {
    return {
      activeKey: 1,
      orderStatus: [],
      storers: []
    }
  },
  created() {
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatus = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    findAll('storerFactory', { available: true }).then(res => {
      if (res.success) {
        this.storers = res.result.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.reset()
    },
    getDetail(row) {
      this.activeKey = 2
      this.$refs.detail.fetch(row)
    }
  }
}
</script>